export default "__VITE_ASSET__Cd6_Pb9f__"